









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { PaymentType } from '@/api/models/PaymentType'

@Component
export default class PaymentTypes extends Vue {
    @Prop({ type: Array, default: () => [] })
    private systemPaymentTypes!: Array<PaymentType>

    private selectedPaymentTypes: Array<PaymentType> = []

    @Watch('systemPaymentTypes')
    paymentTypes() {
        this.selectedPaymentTypes = this.systemPaymentTypes.slice(0)
    }

    changeActive(paymentType: PaymentType) {
        if (!paymentType.active) {
            paymentType.cod = false
        }

        this.$emit('updatePaymentPermission', paymentType)
    }

    changeCod(paymentType: PaymentType) {
        if (paymentType.cod) {
            paymentType.active = true
        }

        this.$emit('updatePaymentPermission', paymentType)
    }
}
